<template>
	<div class="mortgage-calcnew__tabscalc mortgage-calcnew__tabscalc_full _mt-12" :class="{'tabscalc_partner': partnerPage}">
		<div class="mortgage-calcnew__bwrapper">
			<button class="mortgage-calcnew__buy mortgage-calcnew__butt"
				:class="{mtab_active: tabActive === 'buy'}"
				data-code="product_building"
				@click.prevent="setActive('buy')">Покупка</button>
		</div>
		<div class="mortgage-calcnew__rwrapper">
			<button class="mortgage-calcnew__refin mortgage-calcnew__butt"
				:class="{mtab_active: tabActive === 'refin'}"
				data-code="product_refinancing"
				@click.prevent="setActive('refin')"
				:disabled="refinButtonDisabled"
			>Рефинансирование</button>
		</div>
		<div class="mortgage-calcnew__pwrapper" v-show="!partnerPage">
			<button class="mortgage-calcnew__pledge mortgage-calcnew__butt"
				:class="{mtab_active: tabActive === 'pledge'}"
				data-code="product_secured_loan"
				:disabled="pledgeButtonDisabled"
				@click.prevent="setActive('pledge')">Под залог</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "MortgageCalculatorTabs",

	props: {
		disabledCombinations: {
			type: Array,
			default() {
				return []
			}
		},
		partnerPage: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			tabActive: 'buy'
		}
	},
	methods: {
		setActive(tab) {
			this.tabActive = tab;
			this.$emit('setTabActive', tab);
		}
	},
	computed: {
		refinButtonDisabled() {
			return this.$props.disabledCombinations.indexOf('product_refinancing') !== -1
		},
		pledgeButtonDisabled() {
			return this.$props.disabledCombinations.indexOf('product_secured_loan') !== -1
		}
	}
}
</script>
